export const DASHBOARD_EXPORT_COLUMNS = {
  PREVIEW_LINK: 'PREVIEW_LINK',
  BUSINESS_UNIT_NAME: 'BUSINESS_UNIT_NAME'
};
export const AVAILABLE_EXTRA_FIELDS = [];
export const ALL_AVAILABLE_EXTRA_FIELDS = [DASHBOARD_EXPORT_COLUMNS.PREVIEW_LINK];
export const BUSINESS_UNIT_EXPORT_FIELD = [DASHBOARD_EXPORT_COLUMNS.BUSINESS_UNIT_NAME];